// @ts-nocheck
/* eslint-disable */
/* tslint:disable */
/* prettier-ignore-start */

/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */

// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: 9ca3sE4gAMHXGHWcmrUodR
// Component: yje-V7KktC
import * as React from "react";

import * as p from "@plasmicapp/react-web";
import * as ph from "@plasmicapp/host";

import {
  hasVariant,
  classNames,
  wrapWithClassName,
  createPlasmicElementProxy,
  makeFragment,
  MultiChoiceArg,
  SingleBooleanChoiceArg,
  SingleChoiceArg,
  pick,
  omit,
  useTrigger,
  StrictProps,
  deriveRenderOpts,
  ensureGlobalVariants
} from "@plasmicapp/react-web";

import "@plasmicapp/react-web/lib/plasmic.css";

import projectcss from "./plasmic_main.module.css"; // plasmic-import: 9ca3sE4gAMHXGHWcmrUodR/projectcss
import sty from "./PlasmicDocumentEntry.module.css"; // plasmic-import: yje-V7KktC/css

import FileSvgrepoComsvgIcon from "./icons/PlasmicIcon__FileSvgrepoComsvg"; // plasmic-import: ti9TN1ijP8/icon
import DeleteSvgrepoComsvgIcon from "./icons/PlasmicIcon__DeleteSvgrepoComsvg"; // plasmic-import: OYYpwP9zkc/icon
import vndgoogleAppspngWGcykGvJ from "./images/vndgoogleAppspng.png"; // plasmic-import: WGcyk_gvJ/picture

export type PlasmicDocumentEntry__VariantMembers = {};

export type PlasmicDocumentEntry__VariantsArgs = {};
type VariantPropType = keyof PlasmicDocumentEntry__VariantsArgs;
export const PlasmicDocumentEntry__VariantProps = new Array<VariantPropType>();

export type PlasmicDocumentEntry__ArgsType = {
  children?: React.ReactNode;
};

type ArgPropType = keyof PlasmicDocumentEntry__ArgsType;
export const PlasmicDocumentEntry__ArgProps = new Array<ArgPropType>(
  "children"
);

export type PlasmicDocumentEntry__OverridesType = {
  root?: p.Flex<"div">;
  file?: p.Flex<"div">;
  fileImage?: p.Flex<typeof p.PlasmicImg>;
  svg?: p.Flex<"svg">;
  deleteFile?: p.Flex<"svg">;
};

export interface DefaultDocumentEntryProps {
  children?: React.ReactNode;
  className?: string;
}

function PlasmicDocumentEntry__RenderFunc(props: {
  variants: PlasmicDocumentEntry__VariantsArgs;
  args: PlasmicDocumentEntry__ArgsType;
  overrides: PlasmicDocumentEntry__OverridesType;

  forNode?: string;
}) {
  const { variants, overrides, forNode } = props;

  const $ctx = ph.useDataEnv?.() || {};
  const args = React.useMemo(
    () =>
      Object.assign(
        {},

        props.args
      ),
    [props.args]
  );

  const $props = {
    ...args,
    ...variants
  };

  const currentUser = p.useCurrentUser?.() || {};

  return (
    <div
      data-plasmic-name={"root"}
      data-plasmic-override={overrides.root}
      data-plasmic-root={true}
      data-plasmic-for-node={forNode}
      className={classNames(
        projectcss.all,
        projectcss.root_reset,
        projectcss.plasmic_default_styles,
        projectcss.plasmic_mixins,
        projectcss.plasmic_tokens,
        sty.root
      )}
    >
      {true ? (
        <div className={classNames(projectcss.all, sty.freeBox__gTXg)}>
          <div
            data-plasmic-name={"file"}
            data-plasmic-override={overrides.file}
            className={classNames(projectcss.all, sty.file)}
          >
            {true ? (
              <div className={classNames(projectcss.all, sty.freeBox__zRhIa)}>
                <p.PlasmicImg
                  data-plasmic-name={"fileImage"}
                  data-plasmic-override={overrides.fileImage}
                  alt={""}
                  className={classNames(sty.fileImage)}
                  displayHeight={"10px" as const}
                  displayMaxHeight={"none" as const}
                  displayMaxWidth={"100%" as const}
                  displayMinHeight={"0" as const}
                  displayMinWidth={"0" as const}
                  displayWidth={"auto" as const}
                  loading={"lazy" as const}
                  src={{
                    src: vndgoogleAppspngWGcykGvJ,
                    fullWidth: 16,
                    fullHeight: 16,
                    aspectRatio: undefined
                  }}
                />

                <FileSvgrepoComsvgIcon
                  data-plasmic-name={"svg"}
                  data-plasmic-override={overrides.svg}
                  className={classNames(projectcss.all, sty.svg)}
                  role={"img"}
                />
              </div>
            ) : null}

            <div className={classNames(projectcss.all, sty.freeBox__clK6N)}>
              {p.renderPlasmicSlot({
                defaultContents: "Very Long File Name",
                value: args.children
              })}
            </div>
          </div>
        </div>
      ) : null}

      <div className={classNames(projectcss.all, sty.freeBox__pZxr8)}>
        {true ? (
          <DeleteSvgrepoComsvgIcon
            data-plasmic-name={"deleteFile"}
            data-plasmic-override={overrides.deleteFile}
            className={classNames(projectcss.all, sty.deleteFile)}
            role={"img"}
          />
        ) : null}
      </div>
    </div>
  ) as React.ReactElement | null;
}

const PlasmicDescendants = {
  root: ["root", "file", "fileImage", "svg", "deleteFile"],
  file: ["file", "fileImage", "svg"],
  fileImage: ["fileImage"],
  svg: ["svg"],
  deleteFile: ["deleteFile"]
} as const;
type NodeNameType = keyof typeof PlasmicDescendants;
type DescendantsType<T extends NodeNameType> =
  typeof PlasmicDescendants[T][number];
type NodeDefaultElementType = {
  root: "div";
  file: "div";
  fileImage: typeof p.PlasmicImg;
  svg: "svg";
  deleteFile: "svg";
};

type ReservedPropsType = "variants" | "args" | "overrides";
type NodeOverridesType<T extends NodeNameType> = Pick<
  PlasmicDocumentEntry__OverridesType,
  DescendantsType<T>
>;
type NodeComponentProps<T extends NodeNameType> =
  // Explicitly specify variants, args, and overrides as objects
  {
    variants?: PlasmicDocumentEntry__VariantsArgs;
    args?: PlasmicDocumentEntry__ArgsType;
    overrides?: NodeOverridesType<T>;
  } & Omit<PlasmicDocumentEntry__VariantsArgs, ReservedPropsType> & // Specify variants directly as props
    // Specify args directly as props
    Omit<PlasmicDocumentEntry__ArgsType, ReservedPropsType> &
    // Specify overrides for each element directly as props
    Omit<
      NodeOverridesType<T>,
      ReservedPropsType | VariantPropType | ArgPropType
    > &
    // Specify props for the root element
    Omit<
      Partial<React.ComponentProps<NodeDefaultElementType[T]>>,
      ReservedPropsType | VariantPropType | ArgPropType | DescendantsType<T>
    >;

function makeNodeComponent<NodeName extends NodeNameType>(nodeName: NodeName) {
  type PropsType = NodeComponentProps<NodeName> & { key?: React.Key };
  const func = function <T extends PropsType>(
    props: T & StrictProps<T, PropsType>
  ) {
    const { variants, args, overrides } = React.useMemo(
      () =>
        deriveRenderOpts(props, {
          name: nodeName,
          descendantNames: [...PlasmicDescendants[nodeName]],
          internalArgPropNames: PlasmicDocumentEntry__ArgProps,
          internalVariantPropNames: PlasmicDocumentEntry__VariantProps
        }),
      [props, nodeName]
    );

    return PlasmicDocumentEntry__RenderFunc({
      variants,
      args,
      overrides,
      forNode: nodeName
    });
  };
  if (nodeName === "root") {
    func.displayName = "PlasmicDocumentEntry";
  } else {
    func.displayName = `PlasmicDocumentEntry.${nodeName}`;
  }
  return func;
}

export const PlasmicDocumentEntry = Object.assign(
  // Top-level PlasmicDocumentEntry renders the root element
  makeNodeComponent("root"),
  {
    // Helper components rendering sub-elements
    file: makeNodeComponent("file"),
    fileImage: makeNodeComponent("fileImage"),
    svg: makeNodeComponent("svg"),
    deleteFile: makeNodeComponent("deleteFile"),

    // Metadata about props expected for PlasmicDocumentEntry
    internalVariantProps: PlasmicDocumentEntry__VariantProps,
    internalArgProps: PlasmicDocumentEntry__ArgProps
  }
);

export default PlasmicDocumentEntry;
/* prettier-ignore-end */
